import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import { autoTranslate } from "@web-monorepo/vite-auto-translate-plugin/runtime";
import { IdeasPencilIcon } from "components/IdeasIcons";
import React, { ReactNode } from "react";

type SavedToolButtonProps = {
  onRowClick: VoidFunction;
  onEditClick: VoidFunction | null;
  children: ReactNode;
  /**
   * The name will get used for automated product events.
   * @see https://www.notion.so/classdojo/Automatic-Product-Events-for-Web-bfc580f10a914c3ba514e5ec20f8ef9e?pvs=4
   */
  "data-name": string;
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class SavedToolButton extends React.Component<SavedToolButtonProps> {
  render() {
    const { "data-name": dataName, children, onRowClick, onEditClick } = this.props;

    return (
      <li sx={listItemStyle}>
        <button onClick={onRowClick} sx={buttonTextStyle} data-name={dataName}>
          {children}
        </button>
        {onEditClick && (
          <button
            data-name="saved_tool_button:render:ideas_pencil_icon"
            sx={buttonStyle}
            onClick={(e) => {
              e.stopPropagation();
              onEditClick?.();
            }}
            aria-label={autoTranslate("Edit item")}
          >
            <IdeasPencilIcon size="m" />
          </button>
        )}
      </li>
    );
  }
}

const listItemStyle: ThemeUIStyleObject = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  minHeight: "80px",
  width: "100%",
  margin: RAW_cssValue("10px 0"),
  border: "dt_card",
  borderRadius: "dt_radius_s",
  fontSize: "18px",
  textAlign: "left",
  verticalAlign: "middle",
  boxShadow: "dt_shadow_shadezies",
  cursor: "pointer",
  userSelect: "none",
};

const buttonStyle: ThemeUIStyleObject = {
  textAlign: "left",
  minHeight: "inherit",
  padding: RAW_cssValue("0 15px"),
  backgroundColor: "transparent",
  border: "none",
};

const buttonTextStyle: ThemeUIStyleObject = {
  ...buttonStyle,
  flex: "1",
  wordWrap: "break-word",
  minWidth: "50%",
  lineHeight: 1.2,
};
